import React, { Component } from 'react';
import './TutorialPage.css';

// Phase 2: Redux Integration - UNCOMMENTED
import { connect } from 'react-redux';

// Phase 3: i18n Integration - UNCOMMENTED
import { withTranslation } from 'react-i18next';

// Phase 4: Navigation - UNCOMMENTED
import { useNavigate } from 'react-router-dom';

// Phase 7: SVG Icons Integration - UNCOMMENTED ✅ COMPLETED
// Note: Using ReactComponent import for better SVG handling - matches ProgressSummaryPage pattern
import { ReactComponent as GoalsFocus130Icon } from '../../../assets/icons/tab-bar/goals-focus-130.svg';
import { ReactComponent as AnnouncementFocus130Icon } from '../../../assets/icons/tab-bar/announcement-focus-130.svg';
import { ReactComponent as CalendarFocus130Icon } from '../../../assets/icons/tab-bar/calendar-focus-130.svg';

// Phase 5: Carousel Library - UNCOMMENTED ✅ COMPLETED (React Responsive Carousel - similar to react-native-carousel-view)
// Note: Updated to match reference TutorialScreen exactly - no arrows, no background colors, no animations, fixed slide conflicts
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel as CarouselComponent } from 'react-responsive-carousel';

interface TutorialPageProps {
  // Phase 3: i18n Props - UNCOMMENTED
  t: (key: string) => string;
  // Phase 4: Navigation Props - UNCOMMENTED
  navigate: (path: string) => void;
}

class TutorialPage extends Component<TutorialPageProps> {
  constructor(props: TutorialPageProps) {
    super(props);
    // No state needed - matches reference project
  }

  // Phase 2: Component Lifecycle - SIMPLIFIED to match reference
  componentDidMount() {
    // Handle back button logic for web - REMOVED to match reference
    // window.addEventListener('beforeunload', this.handleBeforeUnload);
    
    // Phase 6: Simulate loading for demo purposes - REMOVED to match reference
    // this.simulateInitialLoad();
  }

  componentWillUnmount() {
    // window.removeEventListener('beforeunload', this.handleBeforeUnload); // Removed to match reference
  }

  // Phase 2: Navigation Methods - REMOVED to match reference
  // handleBeforeUnload = (event: BeforeUnloadEvent) => {
  //   // Web equivalent of Android back button logic
  //   // if (this.state.backButtonCount > 1) { // Removed backButtonCount check
  //   //   // Allow page to unload
  //   //   return;
  //   // } else {
  //   // Prevent unload and show message
  //   event.preventDefault();
  //   event.returnValue = 'Press again to exit';
  //   // this.setState({ backButtonCount: this.state.backButtonCount + 1 }); // Removed backButtonCount update
  //   
  //   // Reset counter after showing message
  //   setTimeout(() => {
  //     // this.setState({ backButtonCount: 0 }); // Removed backButtonCount reset
  //   }, 2000);
  //   // }
  // }

  // Phase 4: Navigation Methods - UNCOMMENTED
  _onSignUpPress = () => {
    if (this.props.navigate) {
      this.props.navigate('/signup');
    }
  }

  _onLoginPress = () => {
    if (this.props.navigate) {
      this.props.navigate('/login');
    }
  }

  // Phase 5: Carousel Methods - SIMPLIFIED to match reference
  // handleSlideChange = (index: number) => {
  //   // This function is no longer needed as CarouselComponent handles slide changes
  // }

  // nextSlide = () => {
  //   // This function is no longer needed as CarouselComponent handles slide changes
  // }

  // prevSlide = () => {
  //   // This function is no longer needed as CarouselComponent handles slide changes
  // }

  // goToSlide = () => {
  //   // This function is no longer needed as CarouselComponent handles slide changes
  // }

  // Phase 6: Additional Methods - REMOVED to match reference
  // simulateInitialLoad = () => {
  //   // Simulate loading time for demo purposes
  //   setTimeout(() => {
  //     // this.setState({ loading: false }); // Removed pre-loading state
  //   }, 1500);
  // }

  // handleRetry = () => {
  //   // this.setState({ error: null, loading: true }); // Removed pre-loading state
  //   this.simulateInitialLoad();
  // }

  render() {
    // Phase 2: State Destructuring - REMOVED to match reference
    // const { backButtonCount } = this.state; // Removed backButtonCount
    // Phase 3: i18n Destructuring - UNCOMMENTED
    const { t } = this.props;
    // Phase 6: Additional State Destructuring - REMOVED to match reference
    // const { loading, error } = this.state; // Removed pre-loading state

    // Phase 7: Carousel Data with SVG Icons - UNCOMMENTED
    const slides = [
      {
        icon: <GoalsFocus130Icon className="slide-svg" />,
        title: t("tutorial-screen:title.goals"),
        content: t("tutorial-screen:content.goals"),
        className: "slide-goals"
      },
      {
        icon: <AnnouncementFocus130Icon className="slide-svg" />,
        title: t("tutorial-screen:title.announcements"),
        content: t("tutorial-screen:content.announcements"),
        className: "slide-announcements"
      },
      {
        icon: <CalendarFocus130Icon className="slide-svg" />,
        title: t("tutorial-screen:title.calendar"),
        content: t("tutorial-screen:content.calendar"),
        className: "slide-calendar"
      }
    ];

    // Phase 6: Loading State - UNCOMMENTED
    // if (loading) { // Removed pre-loading state
    //   return (
    //     <div className="tutorial-page">
    //       <div className="loading-container">
    //         <div className="loading-spinner"></div>
    //         <p className="loading-text">{t("common:loading")}</p>
    //       </div>
    //     </div>
    //   );
    // }

    // Phase 6: Error State - UNCOMMENTED
    // if (error) { // Removed pre-loading state
    //   return (
    //     <div className="tutorial-page">
    //       <div className="error-container">
    //         <div className="error-icon">⚠️</div>
    //         <h2 className="error-title">{t("common:error")}</h2>
    //         <p className="error-message">{error}</p>
    //         <button className="error-retry-button" onClick={this.handleRetry}>
    //           {t("common:retry")}
    //         </button>
    //       </div>
    //     </div>
    //   );
    // }

    return (
      <div className="tutorial-page">
        {/* Header Section */}
        <div className="tutorial-header">
          <div className="logos-container">
            <img 
              src={require('../../../assets/icons/cdc-logo.png')} 
              alt="CDC Logo" 
              className="logo-cdc"
            />
            <img 
              src={require('../../../assets/icons/fwd-logo.png')} 
              alt="FWD Logo" 
              className="logo-fwd"
            />
          </div>
        </div>

        {/* Body Section - Carousel */}
        <div className="tutorial-body">
          {/* Phase 5: Custom Carousel Implementation - UNCOMMENTED */}
          <div className="carousel-container">
            {/* Carousel Slides */}
            <CarouselComponent
              showArrows={false}
              showStatus={false}
              showThumbs={false}
              infiniteLoop={false}
              autoPlay={false}
              // Smooth animation: 350ms is a good default for human-perceived smoothness
              transitionTime={350}

              // Swipe behavior
              swipeable={true}                         // enable swiping
              emulateTouch={true}                      // allow mouse to drag like touch on desktop. Good for trackpads.
              preventMovementUntilSwipeScrollTolerance={true} // avoid accidental drags while scrolling vertically
              swipeScrollTolerance={30}                // how many pixels required to trigger a horizontal swipe

              // Accessibility & UX
              useKeyboardArrows={true}                 // left/right with keyboard
              stopOnHover={true}                       // if you later enable autoplay, this is useful
            >
              {slides.map((slide, index) => (
                <div key={index} className={`carousel-slide ${slide.className}`}>
                  <div className="slide-icon">
                    {/* Phase 7: SVG Icons - UNCOMMENTED */}
                    {slide.icon}
                  </div>
                  <h2 className="slide-title">
                    {slide.title}
                  </h2>
                  <p className="slide-content">
                    {slide.content}
                  </p>
                </div>
              ))}
            </CarouselComponent>
          </div>
        </div>

        {/* Footer Section - Buttons */}
        <div className="tutorial-footer">
          <button 
            className="button-signup comman-btn"
            // Phase 4: Navigation - UNCOMMENTED
            onClick={this._onSignUpPress}
          >
            {/* Phase 3: i18n Integration - UNCOMMENTED */}
            {t("tutorial-screen:button.sign-up")}
          </button>
          <button 
            className="button-login comman-btn"
            // Phase 4: Navigation - UNCOMMENTED
            onClick={this._onLoginPress}
          >
            {/* Phase 3: i18n Integration - UNCOMMENTED */}
            {t("tutorial-screen:button.login")}
          </button>
        </div>

        {/* Phase 2: Back Button Counter Display - REMOVED to match reference */}
        {/* {backButtonCount > 0 && (
          <div className="back-button-counter">
            Back button pressed: {backButtonCount} times
          </div>
        )} */}

        {/* Phase 6: Success Animation - REMOVED to match reference */}
        {/* <div className="success-animation">
          <div className="success-checkmark">✓</div>
        </div> */}
      </div>
    );
  }
}

// Phase 2: Redux Connection - UNCOMMENTED
const mapStateToProps = (state: any) => {
  return {
    // Add any Redux state props here if needed in future phases
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    // Add any Redux actions here if needed in future phases
  }
}

// Phase 2 & 3: Export with Redux + i18n - UNCOMMENTED
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TutorialPage));

// Phase 3: Export with i18n only - COMMENTED OUT
// export default withTranslation()(TutorialPage);

// Phase 1: Basic export without Redux/i18n - COMMENTED OUT
// export default TutorialPage;
